import styled from 'styled-components';

import CommonContainer from 'ggApp/shared/common/Container';
import { SubHeadline, Paragraph } from 'ggApp/shared/common/Typography';
import { elevation, elevationTransition } from 'ggApp/utils/mixins';
import Close from 'ggApp/shared/icons/close';

const MAIN_BACKGROUND = 'rgba(23, 204, 168, 0.1)';

// background set to #ffffff directly to preserve color of child Background div.
const Container = styled(CommonContainer)`
    border-radius: 8px;
    background: #ffffff;
    padding: ${({ theme }) => theme.spacers.XL};
`;

const Background = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    background: ${MAIN_BACKGROUND};
    border-radius: 8px;
    top: 0;
    left: 0;
`;

const ContentWrap = styled(CommonContainer)`
    display: flex;
    height: 100%;
    width: 100%;
    z-index: 1;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `}
`;

const Icon = styled.img`
    height: 24px;
    width: 24px;
    flex: 0 0 auto;
    margin: 2px ${({ theme }) => theme.spacers.XL} 0 0;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 0 0 ${theme.spacers.L} 0;
    `}
`;

const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        > * {
            text-align: center;
        }
    `}
`;

const Header = styled(SubHeadline)`
    margin-bottom: ${({ theme }) => theme.spacers.L};
`;

const Description = styled(Paragraph)``;

const CloseButton = styled.div`
    width: 32px;
    height: 32px;
    background-color: ${({ theme }) => theme.colors.Background};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    position: absolute;
    z-index: 1;
    top: 16px;
    right: 16px;
    cursor: pointer;
    ${elevation(0, false)}
    ${elevationTransition(false)}
    &:hover,
    &:focus {
        outline: none;
        ${elevation(2, false, MAIN_BACKGROUND, MAIN_BACKGROUND)};
    }
    &:active {
        ${elevation(1, false, MAIN_BACKGROUND, MAIN_BACKGROUND)};
    }
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        top: 20px;
        right: 20px;
    `}
`;

const CloseIcon = styled(Close)`
    height: 24px;
    width: 24px;
`;

export {
    Container,
    Background,
    ContentWrap,
    Icon,
    TextWrap,
    Header,
    Description,
    CloseButton,
    CloseIcon,
};
